<template>
  <v-row class="mx-0 px-0 dense pb-0">

    <v-col cols="12" md="8" class="pb-0 px-0">
      <v-col class="px-0 py-0" cols="12" md="8">
        <div class="text-body-2 font-weight-medium">
          Profile Photo
        </div>
      </v-col>
      <v-card color="#F6F7FC" class="py-8">
      <v-col cols="12" class="d-flex justify-center mb-3">

        <div
            v-if="this.currentSpeaker.displayImageURL == ''" class="fab rounded-circle circular-dropzone-border d-flex flex-column justify-center align-center cursor-pointer text-center "
            style="width: 155px; height: 155px"
            @click="showUploadLogoDialog = true"
            v-ripple="{ center: true, class: 'rounded-circle' }"
        >

          <div>
            <v-icon>mdi-image-outline</v-icon>
          </div>
          <div class="font-weight-bold">
            Upload speaker <br/>profile photo
          </div>
        </div>
        <div v-else class="d-flex align-center fab circle">
          <div class="d-flex align-center">
            <v-card class="mr-2 pa-0 outlined-border circle">
              <v-img
                  :aspect-ratio="1"
                  height="155"
                  width="155"
                  :src="this.currentSpeaker.displayImageURL"
              >
              </v-img>
            </v-card>
            <div class="text-center mr-2 mt-2">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-avatar
                      color="white"
                      class="elevation-5 d-block mb-2"
                      size="25"
                      v-bind="attrs"
                      v-on="on"
                      @click="showUploadLogoDialog = true"
                  >
                    <v-icon small>mdi-image</v-icon>
                  </v-avatar>
                </template>
                <span>
                          Change image
                        </span>
              </v-tooltip>
              <AvatarButton
                  icon="mdi-trash-can"
                  tooltipText="Delete Image"
                  className="d-inline-block mr-2"
                  @click="handleDeleteLogo"
              />
            </div>
          </div>
        </div>
        <div
            class="error--text"
            v-if="showDisplayImageURLValidationError"
        >
          Sponsor's profile photo is required
        </div>

      </v-col>
        <UploadImageDialog
            :show="showUploadLogoDialog"
            isDisplayImage
            previewType="displayImageURL"
            ref="uploadCoverImageDialog"
            @close="showUploadLogoDialog = false"
            @uploaded="handleSpeakerImageAdded"
            :uploadToBusinessProfile="false"
            :generateCompressedImage="false"
        />
      </v-card>
    </v-col>

    <v-col cols="12" md="8">
      <v-row>
        <v-col cols="6" class="pb-0">
          <v-col class="px-0 py-0" cols="12" md="12">
            <div class="text-body-2 font-weight-medium">
              First Name
            </div>
          </v-col>
          <v-text-field outlined dense :rules="requiredRules" validate-on-blur placeholder="First Name"
                        v-model="currentSpeaker.firstName"></v-text-field>
        </v-col>
        <v-col cols="6" class="pb-0">
          <v-col class="px-0 py-0" cols="12" md="12">
            <div class="text-body-2 font-weight-medium">
              Last Name
            </div>
          </v-col>
          <v-text-field outlined dense :rules="requiredRules" validate-on-blur placeholder="Last Name"
                        v-model="currentSpeaker.lastName"></v-text-field>
        </v-col>


          <v-col cols="12" class="pb-0"
          >
            <v-text-field
                dense
                outlined
                :rules="requiredRules"
                label="Job Title/Role"
                placeholder="Job Title/Role"
                v-model="currentSpeaker.jobTitle"
            />
          </v-col>
          <v-col cols="12" class="pb-0"
          >
            <v-text-field
                dense
                outlined
                label="Company"
                placeholder="Company"
                v-model="currentSpeaker.businessName"
            />
          </v-col>
          <v-col cols="12" class="pb-0"
          >
            <v-text-field
                dense
                outlined
                :rules="requiredRules"
                label="Email"
                placeholder="Email"
                v-model="currentSpeaker.email"
            />
          </v-col>
          <v-col cols="12" class="pb-0"
          >
            <v-textarea
                height="150"
                dense
                outlined
                :rules="requiredRules"
                label="Bio"
                placeholder="Bio"
                v-model="currentSpeaker.bio"
            />
          </v-col>

      </v-row>
    </v-col>

  </v-row>
</template>
<script>
import AvatarButton from "@/components/AvatarButton.vue";
import vueDropzone from "vue2-dropzone";
import {mapGetters} from "vuex";
import UploadImageDialog from "@/components/UploadImageDialog.vue";


export default {
  name: 'EditSpeakerDetails',
  components: {vueDropzone, AvatarButton, UploadImageDialog},
  computed: {
    ...mapGetters(["currentEvent", "currentSpeaker"]),
  },
  methods: {
    handleDeleteLogo() {
      this.currentSpeaker.displayImageURL = "";
      this.refreshCropper = 0;
    },
    handleSpeakerImageAdded(url) {
      this.currentSpeaker.displayImageURL = url;
    },
    updateLogo() {
      this.handleDeleteLogo();
      this.$nextTick(function() {
        this.$refs.speakersImageDropzone.$el.click();
      }.bind(this));
    },
  },
  data() {
    return {
      showDisplayImageURLValidationError: false,

      dropzoneOptions: {
        autoProcessQueue: false,
        url: "http://localhost",
        previewsContainer: false,
        thumbnailWidth: 150,
        thumbnailHeight: 150,
        addRemoveLinks: false,
        acceptedFiles: ".jpg, .jpeg, .png",
      },
      requiredRules: [
        v => !!v || "Required",
      ],
      showUploadLogoDialog: false,
    }
  }

}
</script>
<style>

.imageCardBg {
  background-color: #F6F7FC;
}

</style>